const STORAGE_KEY = 'mj-newsletter-popup-seen';

function readSeen() {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === '1';
  } catch (error) {
    return false;
  }
}

function markSeen() {
  try {
    window.localStorage.setItem(STORAGE_KEY, '1');
  } catch (error) {
    // Storage blocked: the popup will show again next visit.
  }
}

function init() {
  const dialog = document.querySelector('[data-js="newsletter-popup"]');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const closeButton = dialog.querySelector('[data-js="popup-close"]');
  const success = dialog.querySelector('[data-js="popup-success"]');

  function close() {
    markSeen();
    dialog.close();
  }

  if (closeButton) closeButton.addEventListener('click', close);
  dialog.addEventListener('cancel', markSeen);
  dialog.addEventListener('click', function onBackdropClick(event) {
    if (event.target === dialog) close();
  });

  if (success) {
    markSeen();
    dialog.showModal();
    return;
  }

  if (dialog.hasAttribute('data-design-mode') || readSeen()) return;

  const delay = Number(dialog.dataset.delay || 8) * 1000;
  window.setTimeout(function showPopup() {
    if (document.querySelector('cart-drawer.active')) return;
    dialog.showModal();
  }, delay);
}

init();
